// export default class Pagination {
//   pages = 0;
//   currentPage = 0;
//   elements = 0;
//   totalElements = 0;
//   filters = {};
//   constructor(pages, currentPage, elements, totalElements, filters) {
//     this.pages = pages || 0;
//     this.currentPage = currentPage || 0;
//     this.elements = elements || 0;
//     this.totalElements = totalElements || 0;
//     this.filters = filters || {};
//   }
// }
export class Pagination {
  currentPage = 0;
  elements = 0;
  filters = {};
  constructor( {currentPage, elements,  filters}) {
    this.currentPage = currentPage || 0;
    this.elements = elements || 0;
    this.filters = filters || {};
  }
}
export class PaginationResponse extends Pagination {
  pages = 0;
  totalElements = 0;
  constructor(pages, currentPage, elements, totalElements, filters) {
    super({currentPage,elements,filters})
    this.pages = pages || 0;
    this.totalElements = totalElements || 0;
  }
}
